import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme/palette';
import { SvgIconProps } from './SvgIcon.types';

export const BellIcon = memo(({ className, fontSize, color = colors.primary.main }: SvgIconProps) => {
  return (
    <SvgIcon className={className} style={{ fontSize }} width="15" height="18" viewBox="0 0 15 18" fill="none">
      <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.49213 0.76355C4.59264 0.76355 2.24213 3.11405 2.24213 6.01355V8.26355C2.24213 8.26355 2.26163 12.4358 1.07588 13.3538C1.03113 13.3836 1.00829 13.437 1.01773 13.4899C1.02717 13.5428 1.0671 13.5851 1.11938 13.5975C5.3214 14.4863 9.66286 14.4863 13.8649 13.5975C13.9172 13.5851 13.9571 13.5428 13.9665 13.4899C13.976 13.437 13.9531 13.3836 13.9084 13.3538C12.7219 12.4358 12.7421 8.26355 12.7421 8.26355V6.01355C12.7421 3.11405 10.3916 0.76355 7.49213 0.76355Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.49219 3.01355C5.83533 3.01355 4.49219 4.3567 4.49219 6.01355"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.50719 14.1135C4.50719 14.1645 4.49219 14.2118 4.49219 14.2635C4.49219 15.9204 5.83533 17.2635 7.49219 17.2635C9.14904 17.2635 10.4922 15.9204 10.4922 14.2635C10.4922 14.2118 10.4794 14.1645 10.4772 14.1135C8.49189 14.307 6.49248 14.307 4.50719 14.1135Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
});
